<template>
  <div class="aaw-header">
  <!-- header -->
    <div class="header-transparent">
       <!-- navigation start -->
       <div class="container">
           <div class="row">
               <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                   <nav class="navbar navbar-expand-lg navbar-transparent">
                       <a class="navbar-brand" href="index.html"> <img src="../assets/images/aaw-logo.png" alt=""></a>
                       <button class="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbar-transparent" aria-controls="navbar-transparent" aria-expanded="false" aria-label="Toggle navigation">
                           <span class="icon-bar top-bar mt-0"></span>
                           <span class="icon-bar middle-bar"></span>
                           <span class="icon-bar bottom-bar"></span>
                       </button>
                       <div class="collapse navbar-collapse" id="navbar-transparent">
                            <ul class="navbar-nav ml-auto mt-2 mt-lg-0 mr-3">
                                <li class="nav-item">
                                  <a class="nav-link" href="/category/dress">新人穿戴</a>
                                </li>
                                <li class="nav-item">
                                  <a class="nav-link" href="/category/makeup">美妝</a>
                                </li>
                                <li class="nav-item">
                                  <a class="nav-link" href="/category/photography">婚照錄像</a>
                                </li>
                                <li class="nav-item">
                                  <a class="nav-link" href="/category/venue">婚禮場地</a>
                                </li>
                                <li class="nav-item">
                                  <a class="nav-link" href="/category/service">婚禮服務</a>
                                </li>
                                <li class="nav-item">
                                  <a class="nav-link" href="/category/travel">旅遊</a>
                                </li>
                            </ul>
                       <!-- <ul class="navbar-nav ml-auto mt-2 mt-lg-0 mr-3">
                               <li class="nav-item dropdown">
                                   <a class="nav-link dropdown-toggle" href="index.html" id="menu-1"  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                       Homepage
                                   </a>
                                   <ul class="dropdown-menu" aria-labelledby="menu-1">
                                       <li><a class="dropdown-item" href="index.html">
                                               Homepage 1</a>
                                       </li>
                                       <li><a class="dropdown-item" href="index-2.html">
                                               Homepage 2</a>
                                       </li>
                                       <li><a class="dropdown-item" href="index-3.html">
                                               Homepage 3</a>
                                       </li>
                                       <li><a class="dropdown-item" href="index-4.html">
                                               Homepage 4 <span class="badge badge-success">New</span></a>
                                       </li>
                                       <li><a class="dropdown-item" href="index-5.html">
                                               Homepage 5 <span class="badge badge-success">New</span></a>
                                       </li>
                                   </ul>
                               </li>
                               <li class="nav-item dropdown">
                                   <a class="nav-link dropdown-toggle" href="#" id="menu-2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                       Vendors
                                   </a>
                                   <ul class="dropdown-menu" aria-labelledby="menu-2">
                                       <li class="dropdown-submenu">
                                           <a class="dropdown-item dropdown-toggle" href="#">Listing</a>
                                           <ul class="dropdown-menu ">
                                               <li><a class="dropdown-item" href="list-grid-view.html">
                                                       List Grid View</a>
                                               </li>
                                               <li><a class="dropdown-item" href="list-view-sidebar.html">
                                                       List View Sidebar</a>
                                               </li>
                                               <li><a class="dropdown-item" href="list-half-screen-map.html">
                                                       List Half Screen Map</a>
                                               </li>
                                           </ul>
                                       </li>
                                       <li class="dropdown-submenu">
                                           <a class="dropdown-item dropdown-toggle" href="#">List Single</a>
                                           <ul class="dropdown-menu">
                                               <li><a class="dropdown-item" href="list-single-1.html">
                                                       List Single 1</a>
                                               </li>
                                               <li><a class="dropdown-item" href="list-single-2.html">
                                                       List Single 2</a>
                                               </li>
                                               <li><a class="dropdown-item" href="list-single-3.html">
                                                       List Single With Video</a>
                                               </li>
                                               <li><a class="dropdown-item" href="list-single-4.html">
                                                       List Single With Gallery</a>
                                               </li>
                                           </ul>
                                       </li>
                                       <li><a class="dropdown-item" href="vendor-category.html">
                                               Vendor By Categories</a>
                                       </li>
                                       <li><a class="dropdown-item" href="vendor-location.html">
                                               Vendor By Locations</a>
                                       </li>
                                   </ul>
                               </li>
                               <li class="nav-item dropdown">
                                   <a class="nav-link dropdown-toggle" href="" id="menu-3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                       Supplier
                                   </a>
                                   <ul class="dropdown-menu" aria-labelledby="menu-3">
                                       <li><a class="dropdown-item" href="supplier-dresses-list.html" title="">Dresses</a></li>
                                       <li><a class="dropdown-item" href="supplier-cake-list.html" title="">Cakes</a></li>
                                       <li><a class="dropdown-item" href="supplier-florist-list.html" title="">Florist</a></li>
                                       <li><a class="dropdown-item" href="supplier-photographer-list.html" title="">Photographers</a></li>
                                       <li><a class="dropdown-item" href="supplier-videographer-list.html" title="">Videographer</a></li>
                                   </ul>
                               </li>
                               <li class="nav-item dropdown">
                                   <a class="nav-link dropdown-toggle" href="#" id="menu-4" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                       Pages
                                   </a>
                                   <ul class="dropdown-menu" aria-labelledby="menu-4">
                                       <li class="dropdown-submenu">
                                           <a class="dropdown-item dropdown-toggle" href="#">Real Weddings</a>
                                           <ul class="dropdown-menu ">
                                               <li><a class="dropdown-item" href="real-wedding-list.html" title="">Real Weddings List</a></li>
                                               <li><a class="dropdown-item" href="real-wedding-single.html" title="">Real Weddings Single</a></li>
                                           </ul>
                                       </li>
                                       <li class="dropdown-submenu">
                                           <a class="dropdown-item dropdown-toggle" href="#">Forms</a>
                                           <ul class="dropdown-menu ">
                                               <li><a class="dropdown-item" href="vendor-form.html" title="">Vendors Form</a></li>
                                               <li><a class="dropdown-item" href="couple-form.html" title="">Couple Form</a></li>
                                               <li><a class="dropdown-item" href="forgot-password.html" title="">Forgot Password</a></li>
                                           </ul>
                                       </li>
                                       <li class="dropdown-submenu">
                                           <a class="dropdown-item dropdown-toggle" href="#">Help Center</a>
                                           <ul class="dropdown-menu ">
                                               <li><a class="dropdown-item" href="help-center.html" title="">Help Center</a></li>
                                               <li><a class="dropdown-item" href="help-category-list.html" title="">Help Category List</a></li>
                                               <li><a class="dropdown-item" href="help-category-single.html" title="">Help Category Single</a></li>
                                           </ul>
                                       </li>
                                       <li class="dropdown-submenu">
                                           <a class="dropdown-item dropdown-toggle" href="#">Email Template</a>
                                           <ul class="dropdown-menu ">
                                               <li><a class="dropdown-item" href="email-template/new-id-password.html" title="">New ID/Password</a></li>
                                               <li><a class="dropdown-item" href="email-template/reset-password.html" title="">Reset Password</a></li>
                                               <li><a class="dropdown-item" href="email-template/forgot-password.html" title="">Forgot Password</a></li>
                                           </ul>
                                       </li>
                                       <li class="dropdown-submenu">
                                           <a class="dropdown-item dropdown-toggle" href="#">About <span class="badge badge-success">New</span></a>
                                           <ul class="dropdown-menu ">
                                               <li><a class="dropdown-item" href="about-us.html" title="">About v1</a></li>
                                               <li><a class="dropdown-item" href="about-us-2.html" title="">About v2</a></li>
                                               <li><a class="dropdown-item" href="about-us-3.html" title="">About v3 </a></li>
                                               <li><a class="dropdown-item" href="about-us-4.html" title="">About v4 </a></li>
                                           </ul>
                                       </li>
                                       <li><a class="dropdown-item" href="team-page.html" title="">Meet the Team</a></li>
                                       <li><a class="dropdown-item" href="pricing.html" title="">Pricing</a></li>
                                       <li><a class="dropdown-item" href="error-404.html" title="">404</a></li>
                                       <li><a class="dropdown-item" href="faq.html" title="">FAQ's</a></li>
                                       <li><a class="dropdown-item" href="contact-us.html" title="">Contact us</a></li>
                                       <li><a class="dropdown-item" href="vendor-location.html" title="">Vendor Locations</a></li>
                                   </ul>
                               </li>
                               <li class="nav-item dropdown">
                                   <a class="nav-link dropdown-toggle" href="#" id="menu-5" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                       Blog
                                   </a>
                                   <ul class="dropdown-menu" aria-labelledby="menu-5">
                                       <li class="dropdown-submenu">
                                           <a class="dropdown-item dropdown-toggle" href="#">Blog Listing</a>
                                           <ul class="dropdown-menu ">
                                               <li><a class="dropdown-item" href="blog-listing.html" title="">Listing</a></li>
                                               <li><a class="dropdown-item" href="blog-classic.html" title="">Classic</a></li>
                                           </ul>
                                       </li>
                                       <li class="dropdown-submenu">
                                           <a class="dropdown-item dropdown-toggle" href="#">List Single</a>
                                           <ul class="dropdown-menu">
                                               <li><a class="dropdown-item" href="blog-single.html" title="">Blog Single</a></li>
                                               <li><a class="dropdown-item" href="blog-full-screen-single.html" title="">Blog Single Full Screen</a></li>
                                           </ul>
                                       </li>
                                   </ul>
                               </li>
                               <li class="nav-item dropdown mega-dropdown">
                                   <a class="nav-link dropdown-toggle" href="" id="menu-6" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                       Elements <span class="badge badge-success">New</span>
                                   </a>
                                   <ul class="dropdown-menu mega-dropdown-menu" aria-labelledby="menu-6">
                                       <li class="row">
                                           <ul class="col">
                                               <li><a class="dropdown-item" href="shortcode-tabs.html">
                                                       Tabs</a>
                                               </li>
                                               <li><a class="dropdown-item" href="shortcode-accordions.html">
                                                       Accordions</a>
                                               </li>
                                               <li><a class="dropdown-item" href="shortcode-alerts.html">
                                                       Alerts</a>
                                               </li>
                                               <li><a class="dropdown-item" href="shortcode-bullet-list.html">
                                                       Bullet List</a>
                                               </li>

                                           </ul>
                                           <ul class="col">

                                               <li><a class="dropdown-item" href="shortcode-dropcap.html">
                                                       Drop Cap</a>
                                               </li>

                                               <li><a class="dropdown-item" href="shortcode-buttons.html">
                                                       Buttons</a>
                                               </li>

                                               <li><a class="dropdown-item" href="shortcode-blockquote.html">
                                                       Blockquotes</a>
                                               </li>
                                               <li><a class="dropdown-item" href="shortcode-email-subscriber.html">
                                                       Email Subscriber</a>
                                               </li>
                                           </ul>
                                           <ul class="col">

                                               <li><a class="dropdown-item" href="shortcode-socialmedia.html">
                                                       Social Media</a>
                                               </li>
                                               <li><a class="dropdown-item" href="shortcode-typography.html">
                                                       Typography</a>
                                               </li>
                                           </ul>

                                       </li>
                                   </ul>
                               </li>
                               <li class="nav-item dropdown">
                                   <a class="nav-link dropdown-toggle" href="#" id="menu-7" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                       User Panel
                                   </a>
                                   <ul class="dropdown-menu" aria-labelledby="menu-7">
                                       <li class="dropdown-submenu">
                                           <a class="dropdown-item dropdown-toggle" href="#">Vendor Dashboard </a>
                                           <ul class="dropdown-menu ">
                                               <li><a class="dropdown-item" href="vendor-dashboard-overview.html" title="">Dashboard</a></li>
                                               <li><a class="dropdown-item" href="vendor-dashboard-listing.html" title="">Listing</a></li>
                                               <li><a class="dropdown-item" href="vendor-dashboard-add-listing.html" title="">Add Listing</a></li>
                                               <li><a class="dropdown-item" href="vendor-dashboard-pricing.html" title="">Pricing</a></li>
                                               <li><a class="dropdown-item" href="vendor-dashboard-request-quote.html" title="">Request Quote</a></li>
                                               <li><a class="dropdown-item" href="vendor-dashboard-reviews.html" title="">Reviews</a></li>
                                               <li><a class="dropdown-item" href="vendor-dashboard-profile.html" title=""> Profile</a></li>
                                           </ul>
                                       </li>
                                       <li class="dropdown-submenu">
                                           <a class="dropdown-item dropdown-toggle" href="#">Couple Dashboard</a>
                                           <ul class="dropdown-menu ">
                                               <li><a class="dropdown-item" href="couple-dashboard-overview.html" title="">Dashboard</a></li>
                                               <li><a class="dropdown-item" href="couple-dashboard-mywishlist.html" title="">My Listing</a></li>
                                               <li><a class="dropdown-item" href="couple-dashboard-todolist" title="">To Do List</a></li>
                                               <li><a class="dropdown-item" href="couple-dashboard-budget.html" title="">Budget</a></li>
                                               <li><a class="dropdown-item" href="couple-dashboard-guest-manager.html" title="">Guest Manager</a></li>
                                               <li><a class="dropdown-item" href="couple-dashboard-add-new-guest.html" title="">Add New Guest</a></li>
                                               <li><a class="dropdown-item" href="couple-dashboard-table-planner.html" title="">Seating Table</a></li>
                                               <li><a class="dropdown-item" href="couple-dashboard-profile.html" title=""> Profile</a></li>
                                           </ul>
                                       </li>
                                       <li><a class="dropdown-item" href="couple-rsvp-page.html" title="">RSVP</a></li>
                                   </ul>
                               </li>
                           </ul>
                           <a href="#" class="btn btn-default btn-sm">Get Started Now</a> -->
                       </div>
                   </nav>
               </div>
           </div>
       </div>
       <!-- navigation close -->
     </div>
   <!-- /.header -->
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    msg: String
  }
};
</script>
